if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const giftPlan = this.getPlumoGiftPlan(formData);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = giftPlan ? this.getPlumoGiftFormData(formData, giftPlan) : formData;

          this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }
        
                fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cartState) => {
            if (giftPlan) {
              if (!giftPlan.giftId || !giftPlan.parentId) throw new Error(giftPlan.errorMessage);
              giftPlan.beforeItems = cartState.items.filter((item) => item.properties?._plumo_gift_pair === giftPlan.pair);
            }
            if (cartState.item_count === 0 && this.upsellVariantId) {
              return fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig());
            }
          })
          .then(() => {
            if (giftPlan) giftPlan.requested = true;
            return fetch(`${routes.cart_add_url}`, config);
          })

          .then((response) => response.json())
          .then(async (response) => {
            if (giftPlan) await this.confirmPlumoGift(giftPlan, response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = "/checkout";
             return;
           } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch(async (e) => {
            if (giftPlan?.requested && !giftPlan.confirmed && !giftPlan.rolledBack) {
              try {
                await this.rollbackPlumoGift(giftPlan);
              } catch (rollbackError) {
                console.error(rollbackError);
              }
            }
            this.error = false;
            this.handleErrorMessage(e.message || window.cartStrings.error);
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
      getPlumoGiftPlan(formData) {
        const controls = Array.from(this.form.elements).filter((input) => input.name === 'properties[Free sleep mask]');
        if (!controls.length) return null;
        const selected = controls.find((input) => input.checked);
        const giftId = Number(selected?.dataset.plumoGiftVariant);
        const parentId = Number(formData.get('id'));
        return {
          giftId: Number.isSafeInteger(giftId) && giftId > 0 ? giftId : null,
          parentId: Number.isSafeInteger(parentId) && parentId > 0 ? parentId : null,
          quantity: Math.max(1, parseInt(formData.get('quantity'), 10) || 1),
          pair: `${parentId}:${giftId}`,
          errorMessage: selected?.closest('.plc-gift-choice')?.dataset.plumoGiftError || window.cartStrings.error,
        };
      }

      getPlumoGiftFormData(formData, plan) {
        const grouped = new FormData();
        for (const [key, value] of formData.entries()) {
          if (['id', 'quantity', 'selling_plan'].includes(key)) grouped.append(`items[0][${key}]`, value);
          else if (key.startsWith('properties[') && key !== 'properties[Free sleep mask]') grouped.append(`items[0][properties][${key.slice(11, -1)}]`, value);
          else if (key === 'sections' || key === 'sections_url') grouped.append(key, value);
        }
        grouped.set('items[0][quantity]', plan.quantity);
        grouped.set('items[0][properties][_plumo_gift_variant]', plan.giftId);
        grouped.set('items[0][properties][_plumo_gift_pair]', plan.pair);
        grouped.set('items[1][id]', plan.giftId);
        grouped.set('items[1][quantity]', plan.quantity);
        grouped.set('items[1][parent_id]', plan.parentId);
        grouped.set('items[1][properties][_plumo_gift]', 'cocoon');
        grouped.set('items[1][properties][_plumo_gift_pair]', plan.pair);
        return grouped;
      }

      async confirmPlumoGift(plan, response) {
        const cartResponse = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error(plan.errorMessage);
        const state = await cartResponse.json();
        const pairItems = state.items.filter((item) => item.properties?._plumo_gift_pair === plan.pair);
        const isGift = (item) => item.properties?._plumo_gift === 'cocoon';
        const count = (items, gift) => items.filter((item) => isGift(item) === gift).reduce((sum, item) => sum + item.quantity, 0);
        const giftItems = pairItems.filter(isGift);
        const parentsCovered = pairItems.filter((item) => !isGift(item)).every((parent) =>
          giftItems.filter((gift) => gift.parent_relationship?.parent_key === parent.key)
            .reduce((sum, gift) => sum + gift.quantity, 0) === parent.quantity
        );
        const valid = !response.status &&
          count(pairItems, false) === count(plan.beforeItems, false) + plan.quantity &&
          count(pairItems, true) === count(plan.beforeItems, true) + plan.quantity &&
          parentsCovered &&
          giftItems.every((item) => item.final_line_price === 0 && item.parent_relationship?.parent_key);
        if (!valid) {
          await this.rollbackPlumoGift(plan, state);
          throw new Error(plan.errorMessage);
        }
        plan.confirmed = true;
        if (response.items?.length) {
          const parent = response.items.find((item) => !isGift(item));
          if (parent) {
            response.id = parent.id;
            response.key = parent.key;
          }
        }
      }

      getPlumoLineSignature(item, items) {
        const describe = (line) => [
          String(line.variant_id || line.id),
          String(line.selling_plan_allocation?.selling_plan?.id || ''),
          Object.entries(line.properties || {}).sort(([left], [right]) => left.localeCompare(right)),
        ];
        const parentKey = item.parent_relationship?.parent_key;
        const parent = parentKey ? items.find((line) => line.key === parentKey) : null;
        return JSON.stringify([describe(item), parent ? describe(parent) : null]);
      }

      async rollbackPlumoGift(plan, state) {
        if (!state) {
          const cartResponse = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error(plan.errorMessage);
          state = await cartResponse.json();
        }
        const pairItems = state.items.filter((item) => item.properties?._plumo_gift_pair === plan.pair);
        const isGift = (item) => item.properties?._plumo_gift === 'cocoon';
        const updates = {};
        const quantities = new Map();
        const parentQuantities = new Map();
        for (const item of plan.beforeItems) {
          const signature = this.getPlumoLineSignature(item, plan.beforeItems);
          quantities.set(signature, (quantities.get(signature) || 0) + item.quantity);
        }
        const restoreQuantity = (item) => {
          const signature = this.getPlumoLineSignature(item, pairItems);
          const remaining = quantities.get(signature) || 0;
          const quantity = Math.min(item.quantity, remaining);
          quantities.set(signature, remaining - quantity);
          return quantity;
        };
        for (const item of pairItems.filter((item) => !isGift(item))) {
          updates[item.key] = restoreQuantity(item);
          parentQuantities.set(item.key, updates[item.key]);
        }
        for (const item of pairItems.filter(isGift)) {
          const parentKey = item.parent_relationship?.parent_key;
          if (parentKey && parentQuantities.get(parentKey) === 0) continue;
          updates[item.key] = restoreQuantity(item);
        }
        if (Object.keys(updates).length) {
          const result = await fetch(routes.cart_update_url, {
            ...fetchConfig(),
            body: JSON.stringify({ updates }),
          });
          if (!result.ok) throw new Error(plan.errorMessage);
          const restored = await result.json();
          if (restored.errors) throw new Error(plan.errorMessage);
        }
        plan.rolledBack = true;
      }

            getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
